import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const tabs = [
    { id: 'pansiyon', label: 'Pansiyon Yönetimi', icon: '🏨' },
    { id: 'rezervasyon', label: 'Rezervasyonlar', icon: '📆' },
    { id: 'yorum', label: 'Yorumlar', icon: '💬' },
    { id: 'kullanici', label: 'Kullanıcılar', icon: '👥' },
    { id: 'ayarlar', label: 'Ayarlar', icon: '⚙️' }
];

export default function AdminPanel() {
    const [activeTab, setActiveTab] = useState('pansiyon');
    const [sidebarOpen, setSidebarOpen] = useState(true);

    return (
        <div className="flex min-h-screen bg-gray-100 text-gray-800">
            {/* Sol Menü - Dark Modern Sidebar */}
            <motion.aside
                initial={{ width: sidebarOpen ? '16rem' : '5rem' }}
                animate={{ width: sidebarOpen ? '16rem' : '5rem' }}
                transition={{ duration: 0.3 }}
                className={`bg-gray-900 shadow-xl flex flex-col ${sidebarOpen ? 'w-64' : 'w-20'} transition-all duration-300`}
            >
                <div className="p-4 border-b border-gray-700 flex items-center justify-between">
                    {sidebarOpen && (
                        <h2 className="text-xl font-bold text-[#F9D923]">Admin Paneli</h2>
                    )}
                    <button
                        onClick={() => setSidebarOpen(!sidebarOpen)}
                        className="text-gray-400 hover:text-white p-1 rounded-lg"
                    >
                        {sidebarOpen ? '◀' : '▶'}
                    </button>
                </div>

                <div className="p-4 border-b border-gray-700 flex flex-col items-center">
                    <div className="w-12 h-12 rounded-full bg-gradient-to-r from-[#F9D923] to-[#FF914D] flex items-center justify-center text-xl font-bold text-white mb-2">
                        A
                    </div>
                    {sidebarOpen && (
                        <>
                            <div className="text-sm font-medium text-white">Admin</div>
                            <div className="text-xs text-gray-400">admin@example.com</div>
                        </>
                    )}
                </div>

                <nav className="flex-1 flex flex-col p-2 space-y-1 overflow-y-auto">
                    {tabs.map((tab) => (
                        <motion.button
                            key={tab.id}
                            whileHover={{ scale: 1.02 }}
                            whileTap={{ scale: 0.98 }}
                            onClick={() => setActiveTab(tab.id)}
                            className={`flex items-center ${sidebarOpen ? 'justify-start px-4 py-3' : 'justify-center p-3'} rounded-lg transition-all duration-200
                                ${activeTab === tab.id
                                    ? 'bg-gradient-to-r from-[#F9D923] to-[#FF914D] text-gray-900 font-semibold'
                                    : 'text-gray-300 hover:bg-gray-700'}
                            `}
                        >
                            <span className="text-xl">{tab.icon}</span>
                            {sidebarOpen && (
                                <span className="ml-3">{tab.label}</span>
                            )}
                        </motion.button>
                    ))}
                </nav>
            </motion.aside>

            {/* Ana İçerik Alanı */}
            <main className="flex-1 overflow-auto p-6">
                {/* Header */}
                <header className="bg-white rounded-xl shadow-sm p-4 mb-6 flex justify-between items-center">
                    <h1 className="text-2xl font-bold text-gray-800">
                        {tabs.find(tab => tab.id === activeTab)?.label}
                    </h1>
                    <div className="flex items-center space-x-4">
                        <button className="p-2 rounded-full bg-gray-200 hover:bg-gray-300">
                            <span>🔔</span>
                        </button>
                        <div className="flex items-center space-x-2">
                            <div className="w-8 h-8 rounded-full bg-gradient-to-r from-[#F9D923] to-[#FF914D] flex items-center justify-center text-white font-bold">
                                A
                            </div>
                            {sidebarOpen && <span className="text-sm font-medium">Admin</span>}
                        </div>
                    </div>
                </header>

                {/* İçerik */}
                <AnimatePresence mode="wait">
                    <motion.div
                        key={activeTab}
                        initial={{ opacity: 0, y: 10 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: -10 }}
                        transition={{ duration: 0.2 }}
                        className="bg-white rounded-xl shadow-sm p-6"
                    >
                        {activeTab === 'pansiyon' && (
                            <div>
                                <h2 className="text-xl font-semibold mb-4">Pansiyon Yönetimi</h2>
                                <p className="text-gray-600">
                                    Tüm pansiyonları listeleyebilir, düzenleyebilir veya silebilirsiniz.
                                </p>
                            </div>
                        )}

                        {activeTab === 'rezervasyon' && (
                            <div>
                                <h2 className="text-xl font-semibold mb-4">Rezervasyon Yönetimi</h2>
                                <p className="text-gray-600">
                                    Rezervasyonları görebilir, onaylayabilir veya iptal edebilirsiniz.
                                </p>
                            </div>
                        )}

                        {activeTab === 'yorum' && (
                            <div>
                                <h2 className="text-xl font-semibold mb-4">Yorum Yönetimi</h2>
                                <p className="text-gray-600">
                                    Kullanıcı yorumlarını inceleyebilir, uygunsuz içerikleri silebilirsiniz.
                                </p>
                            </div>
                        )}

                        {activeTab === 'kullanici' && (
                            <div>
                                <h2 className="text-xl font-semibold mb-4">Kullanıcı Yönetimi</h2>
                                <p className="text-gray-600">
                                    Kullanıcı hesaplarını yönetebilir, yetkileri düzenleyebilirsiniz.
                                </p>
                            </div>
                        )}

                        {activeTab === 'ayarlar' && (
                            <div>
                                <h2 className="text-xl font-semibold mb-4">Sistem Ayarları</h2>
                                <p className="text-gray-600">
                                    Sistem genelindeki ayarları düzenleyebilirsiniz.
                                </p>
                            </div>
                        )}
                    </motion.div>
                </AnimatePresence>
            </main>
        </div>
    );
}